import { HttpService } from 'app/services';
import * as AppActions from 'app/store/actions';
import { parseError } from 'helpers/Error';

export const APPROVE_PENDING_DRUGS = '@DRUG/APPROVE_PENDING_DRUGS';
export const APPROVE_PENDING_DRUGS_SUCCESS = '@DRUG/APPROVE_PENDING_DRUGS_SUCCESS';
export const APPROVE_PENDING_DRUGS_FAIL = '@DRUG/APPROVE_PENDING_DRUGS_FAIL';

export const REJECT_PENDING_DRUGS = '@DRUG/REJECT_PENDING_DRUGS';
export const REJECT_PENDING_DRUGS_SUCCESS = '@DRUG/REJECT_PENDING_DRUGS_SUCCESS';
export const REJECT_PENDING_DRUGS_FAIL = '@DRUG/REJECT_PENDING_DRUGS_FAIL';

export const SET_DRUG_PENDING_FILTER = '@DRUG/SET_DRUG_PENDING_FILTER';

export const setDrugPendingFilter = (filter) => ({
  type: SET_DRUG_PENDING_FILTER,
  payload: { filter },
});

export const approvePendingDrugs = (drugIds) => {
  return (dispatch) => {
    dispatch({ type: APPROVE_PENDING_DRUGS });
    return HttpService.post('api/master-drugs/pending/approve', drugIds)
      .then(() => {
        dispatch(
          AppActions.showMessage({
            message: 'Selected drugs have been approved successfully',
            variant: 'success',
          }),
        );
        dispatch({ type: APPROVE_PENDING_DRUGS_SUCCESS });
        dispatch(AppActions.dataLoader_reload('GET:/api/master-drugs/pending'));
      })
      .catch((err) => {
        const { errorMessages, errorTitle } = parseError(err);
        dispatch({ type: APPROVE_PENDING_DRUGS_FAIL, payload: { message: errorMessages.join('\n') } });
        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
      });
  };
};

export const rejectPendingDrugs = (drugIds) => {
  return (dispatch) => {
    dispatch({ type: REJECT_PENDING_DRUGS });
    return HttpService.post('api/master-drugs/pending/reject', drugIds)
      .then(() => {
        dispatch(
          AppActions.showMessage({
            message: 'Selected drugs have been rejected successfully',
            variant: 'success',
          }),
        );
        dispatch({ type: REJECT_PENDING_DRUGS_SUCCESS });
        dispatch(AppActions.dataLoader_reload('GET:/api/master-drugs/pending'));
      })
      .catch((err) => {
        const { errorMessages, errorTitle } = parseError(err);
        dispatch({ type: REJECT_PENDING_DRUGS_FAIL, payload: { message: errorMessages.join('\n') } });
        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
      });
  };
};
